/* tslint:disable:no-any */
import { DataAccessServiceInterface } from '@central-products/interface-data-access-service';
import {
  ApolloClient,
  OperationVariables,
  QueryOptions,
  MutationOptions,
  WatchQueryOptions,
  ApolloQueryResult,
  ObservableQuery,
} from 'apollo-client';
import { FetchResult } from 'apollo-link';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import { GraphqlClientConfig } from './types';

export class GraphqlClient extends DataAccessServiceInterface {
  private readonly config: GraphqlClientConfig;
  private client?: ApolloClient<NormalizedCacheObject>;

  constructor(config: GraphqlClientConfig) {
    super();

    this.config = config;
  }

  public async getClient() {
    if (this.client) {
      return this.client;
    }

    return import('./createClient').then(({ createClient }) => {
      this.client = createClient(this.config);

      return this.client;
    });
  }

  public query<T = any, TVariables = OperationVariables>(
    options: QueryOptions<TVariables>
  ): Promise<ApolloQueryResult<T>> {
    return (this.getClient().then((client) => client.query(options)) as unknown) as Promise<ApolloQueryResult<T>>;
  }

  public mutate<T = any, TVariables = OperationVariables>(
    options: MutationOptions<T, TVariables>
  ): Promise<FetchResult<T>> {
    return (this.getClient().then((client) => client.mutate(options)) as unknown) as Promise<FetchResult<T>>;
  }

  public watchQuery<T = any, TVariables = OperationVariables>(
    options: WatchQueryOptions<TVariables>
  ): ObservableQuery<T, TVariables> {
    return (this.getClient().then((client) => client.watchQuery(options)) as unknown) as ObservableQuery<T, TVariables>;
  }
}
